<template>
  <div class="flex flex-col items-between gap-4 mx-16 md: m-4">
    <TitreDeux :content="t('createTypeOfFilament')" />
    <InputField :placeholder="t('newLabelTypeOfFilament')" v-model="newLibelle" />
    <InputField :placeholder="t('priceKg')" v-model="newPrice" type="number" />
    <BlueButton :text="t('addAction')" @click="createTypeFilament" />
  </div>
</template>

<script setup>

import {t} from "@/utils/Traduction";
import {ref} from "vue";
import {NotificationStores} from "@/stores/NotificationStores";
import {TypeFilamentStore} from "@/stores/TypeFilamentStore";
import InputField from "@/components/molecules/InputField.vue";
import BlueButton from "@/components/molecules/BlueButton.vue";
import TitreDeux from "@/components/atoms/TitreDeux.vue";

const notificationStores = NotificationStores();
const typeFilamentStore = TypeFilamentStore();

const newLibelle = ref("");
const newPrice = ref("");

const createTypeFilament = () => {
  if(newLibelle.value === "" || newPrice.value < 0 || newPrice.value === "") {
    notificationStores.addNotification(t("needFillAllFields"), 'error');
    return;
  }

  typeFilamentStore.createTypeFilament(newLibelle.value, newPrice.value);
  newLibelle.value = "";
  newPrice.value = "";
}
</script>

<style scoped>

</style>